// kept for backwards compatibility
export default {};